<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Library/Handout Management / View</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="mb40">
                    <div class="add-store-block input-style mb20 ">
                        <form>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12">
                                    <label class="mt20">Doc Name : </label>
                                    <p class="mt-2"> {{libraryList?.title}}</p>
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12">
                                    <label class="mt20">Uploaded File : </label>
                                    
                                     <p class="mt-2 mb-2" style="word-break: break-all;">
                                     <a [href]="libraryList?.document" target="_blank" rel="noopener noreferrer">
                                        <i class="fa fa-file-text "  aria-hidden="true"></i>
                                       </a>     
                                    </p> 
                                </div>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-theme" routerLink="/library-mgt">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>